
import Utility from '../utilities/utility';

const baseUrl = process.env.REACT_APP_BASE_URL;

class OrderService {

    constructor() {

        this.sessionData = JSON.parse(localStorage.getItem('sessionData'));

        console.log(this.sessionData);

    }


    static orders(countryId, desc, fromDate, toDate, stockOrder, productId) {


        const data = JSON.parse(localStorage.getItem('sessionData'));

        let selectedCountry = countryId;

        if (Utility.isEmpty(countryId)) {

            selectedCountry = data.countryId;

        }


        const reqData = {

            'dateFrom': fromDate,
            'dateTo': toDate,
            'description': desc,
            'stockOrder': stockOrder,
            'productId': productId
        };

        return fetch(baseUrl + '/admin/order/list/' + data.companyId + '/' + selectedCountry, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': data.token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        });
    }

    static createOrder(orderDescription, currencyId,branchId, countryId) {

        const reqData = {

            'description': orderDescription,
            'currencyId': currencyId,
            'branchId': branchId,
            'countryId': countryId
        };
        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/order/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        });

    }

    static createSockOrder(orderDescription, currencyId, countryId, customerId, branchId) {

        const reqData = {

            'description': orderDescription,
            'currencyId': currencyId,
            'customerId': customerId,
            'countryId': countryId,
            'branchId': branchId
        };
        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/stock/order/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        });

    }


    createCustomerOrder(orderDto) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/order/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(orderDto)
        });
    }

    static addToOrder(orderId, quantity, productId, price, confirmed = false) {

        const reqData = {
            "orderId": orderId,
            "price": price,
            "quantity": quantity,
            "productId": productId,
            "confirmed": confirmed
        };

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/order/addProduct', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        })

            .catch(error => [])

    }


    static updateOrderProductQuantity(productId, quantity) {

        const reqData = {

            quantity: quantity,
            productId: productId
        };

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/product/update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        })

            .catch(error => [])

    }

    static updateOrderProductPrice(productId, price) {

        const reqData = {

            price: price,
            productId: productId
        };

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/product/update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        })

            .catch(error => [])

    }

    static updateOrderDescription(orderid, description) {

        const reqData = {
            orderId: orderid,
            description: description

        };

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/update/description', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        })

            .catch(error => [])

    }

    static getOrder(orderid) {

        const token = localStorage.getItem('token');

        if (orderid == undefined || orderid == '' || orderid == null) {

            return false;
        }

        return fetch(baseUrl + '/order/fetch/' + orderid, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        })

            .catch(error => [])

    }

    static updateOrderProductStatus(productId, status) {

        const reqData = {
            orderProductId: productId,
            statusId: status

        };

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/update/product/status', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        })

            .catch(error => [])

    }

    static orderSuppliers(orderId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/suppliers/' + orderId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });

    }

    static orderSupplierBalance(orderId, supplierId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/supplier/balance/' + orderId + '/' + supplierId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });

    }


    static statusList(type) {



        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/status/list/' + type, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        })

            .catch(error => [])

    }


    static updateOrderStatus(orderId, status) {

        const reqData = {
            orderId: orderId,
            statusId: status

        };

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/status/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        })

            .catch(error => [])

    }


    static orderProducts(orderId, deleted, changesMade, name, model, brand, size, notLoaded, inStock) {

        const requestData = {
            "orderId": orderId,
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
            "deleted": deleted,
            "changesMade": changesMade,
            "notLoaded": notLoaded,
            "inStock": inStock
        };



        const token = localStorage.getItem('token');



        return fetch(baseUrl + '/order/products/' + orderId, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }


    static newOrders(countryId) {


        const data = JSON.parse(localStorage.getItem('sessionData'));



        return fetch(baseUrl + '/order/country/new', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': data.token,
                'Accept': 'application/json',
            },
            body: JSON.stringify({ 'countryId': countryId })
        });
    }


    static setOrderProductSupplier(orderProductId, supplierId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/product/supplier/update/' + orderProductId + '/' + supplierId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }


    static setOrderSupplier(orderId, supplierId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/supplier/update/' + orderId + '/' + supplierId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }


    static removeOrderProduct(orderProductId, orderId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/order/product/remove/' + orderProductId + '/' + orderId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }

    static printProducts(orderId) {



        const token = localStorage.getItem('token');



        return fetch(baseUrl + '/order/print/products/' + orderId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }

    static updateOrderCurrency(orderId, currencyId) {



        const token = localStorage.getItem('token');

        const requestData = {
            'orderId': orderId,
            'currencyId': currencyId
        };

        return fetch(baseUrl + '/admin/order/currency/update', {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }



    static lockOrder(orderId) {


        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/lock/' + orderId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }

        })

            .catch(error => false)

    }


    static unlockOrder(orderId) {


        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/unlock/' + orderId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }

        })

            .catch(error => false)

    }



    static fetchOrder(orderId) {



        const token = localStorage.getItem('token');



        return fetch(baseUrl + '/admin/order/fetch/' + orderId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }




    static attachCustomerToOrder(customerId, orderId) {


        const data = JSON.parse(localStorage.getItem('sessionData'));



        return fetch(baseUrl + '/admin/order/attach/customer', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': data.token,
                'Accept': 'application/json',
            },
            body: JSON.stringify({ 'customerId': customerId, 'orderId': orderId })
        });
    }

    static acknowledgeOrderProductChanges(productId) {



        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/product/acknowledge/changes/' + productId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        })

            .catch(error => [])

    }



    static convertOrderProductToStockOrder(orderId, orderProductId, quantity) {



        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/product/convert/tostock/order/', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                'newOrderId': orderId,
                'orderProductId': orderProductId,
                'quantity': quantity
            })
        })
            .catch(error => [])

    }


    static customerOrders(customerId, desc, fromDate, toDate) {

        const token = localStorage.getItem('token');


        const reqData = {

            'dateFrom': fromDate,
            'dateTo': toDate,
            'description': desc,
            'customerId': customerId

        };

        return fetch(baseUrl + '/order/customer/order/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        });
    }


    static isOrderFullyLoaded(orderid) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/fully/loaded/' + orderid, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        })

            .catch(error => [])

    }

    static pickOrderFromWarehouse(orderId) {

        const token = localStorage.getItem('token');




        return fetch(baseUrl + '/admin/order/products/pick/' + orderId, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }

        });
    }



    static pickOrderProductFromWarehouse(productId, quantity) {

        const token = localStorage.getItem('token');

        const reqData = {

            'quantity': quantity
        };


        return fetch(baseUrl + '/admin/order/product/pick/' + productId, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)

        });
    }

    static createSupplierOrder(supplierId, description) {

        const token = localStorage.getItem('token');

        const reqData = {

            'supplierId': supplierId,
            'description': description,
        };


        return fetch(baseUrl + '/manager/supplier/order/create', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)

        });
    }


    static productsToOrderFromSupplier(name, model, brand, size, page, pageSize) {

        const token = localStorage.getItem('token');

        const reqData = {

            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
        };

        if (Utility.isEmpty(page)) {

            page = 0;
        }

        if (Utility.isEmpty(pageSize)) {

            pageSize = 1000;
        }


        return fetch(baseUrl + '/manager/supplier/order/products/' + page + '/' + pageSize, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)

        });
    }


    static supplierOrders(supplierId, description, fromDate, toDate) {

        const token = localStorage.getItem('token');

        const reqData = {

            'supplierId': supplierId,
            'dateFrom': fromDate,
            'description': description,
            'dateTo': toDate,
        };


        return fetch(baseUrl + '/manager/supplier/order/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)

        });
    }

    static addSupplierOrderProductToOrder(orderId, productId, quantity, price, confirmed) {

        const token = localStorage.getItem('token');

        const reqData = {

            'orderId': orderId,
            'productId': productId,
            'quantity': quantity,
            'price': !Utility.isEmpty(price) ? price : 0,
            'confirmed': confirmed
        };


        return fetch(baseUrl + '/manager/supplier/order/product/add', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)

        });
    }

    static fetchSupplierOrder(orderId) {

        const token = localStorage.getItem('token');



        return fetch(baseUrl + '/manager/supplier/order/fetch/' + orderId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }

        });
    }

    static supplierOrderProducts(orderId, name, model, brand, size) {

        const requestData = {
            "orderId": orderId,
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,

        };



        const token = localStorage.getItem('token');



        return fetch(baseUrl + '/manager/supplier/order/product/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }


    static updateSupplierOrderProduct(productId, quantity, price) {

        const requestData = {
            "productId": productId,
            "quantity": quantity,
            "price": price
        };



        const token = localStorage.getItem('token');



        return fetch(baseUrl + '/manager/supplier/order/product/update', {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    static removeSupplierOrderProduct(productId) {

        const token = localStorage.getItem('token');



        return fetch(baseUrl + '/manager/supplier/order/product/remove/' + productId, {
            method: 'DELETE',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }

    static updateSupplierOrderDescription(orderId, description) {

        const requestData = {
            "orderId": orderId,
            "description": description,

        };



        const token = localStorage.getItem('token');



        return fetch(baseUrl + '/manager/supplier/order/update', {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    static removeNonShippedOrderProduct(productId, quantity) {

        const reqData = {

            quantity: quantity,
            productId: productId
        };

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/admin/order/remove/non/shipped/product', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(reqData)
        })

            .catch(error => [])

    }

    static getProductImages(productId) {
    return fetch(baseUrl+'/order/product/images/'+productId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token')
        }
    });
}

static deleteOrder(orderId) {
    return fetch(baseUrl + "/admin/order/remove/" + orderId, {
        method: "DELETE",
        headers: {
            "Authorization": localStorage.getItem("token")
        }
    });
}


static generateOrderUniqueNumbers() {

        return fetch(

            baseUrl + "/admin/order/generate-order-unique-numbers",

            {

                method: "POST",

                headers: {

                    "Authorization": localStorage.getItem("token")

                }

            }

        );

    }





}

export default OrderService;